var _circle, _path, _path2, _circle2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankGreenLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 46,
    viewBox: "0 0 42 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 26,
    r: 19.5,
    stroke: "#23BD86",
    strokeOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 23.5V31H18.75V23.5H21.25V31H23.75V23.5H26.25V31H27.6562C27.7806 31 27.8998 31.0494 27.9877 31.1373C28.0756 31.2252 28.125 31.3444 28.125 31.4688V32.25H11.875V31.4688C11.875 31.3444 11.9244 31.2252 12.0123 31.1373C12.1002 31.0494 12.2194 31 12.3438 31H13.75V23.5H16.25Z",
    fill: "#668598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.182 20.7116L20.1195 17.2741C20.043 17.2424 19.957 17.2424 19.8805 17.2741L10.818 20.7116C10.7609 20.7353 10.712 20.7753 10.6777 20.8267C10.6434 20.8781 10.625 20.9385 10.625 21.0003V21.6253C10.625 21.7082 10.6579 21.7877 10.7165 21.8463C10.7751 21.9049 10.8546 21.9378 10.9375 21.9378H11.875V22.4066C11.875 22.5309 11.9244 22.6501 12.0123 22.738C12.1002 22.8259 12.2194 22.8753 12.3438 22.8753H27.6562C27.7806 22.8753 27.8998 22.8259 27.9877 22.738C28.0756 22.6501 28.125 22.5309 28.125 22.4066V21.9378H29.0625C29.1454 21.9378 29.2249 21.9049 29.2835 21.8463C29.3421 21.7877 29.375 21.7082 29.375 21.6253V21.0003C29.375 20.9385 29.3566 20.8781 29.3223 20.8267C29.288 20.7753 29.2391 20.7353 29.182 20.7116ZM28.4375 32.8753H11.5625C11.3139 32.8753 11.0754 32.9741 10.8996 33.1499C10.7238 33.3257 10.625 33.5642 10.625 33.8128V34.4378C10.625 34.5207 10.6579 34.6002 10.7165 34.6588C10.7751 34.7174 10.8546 34.7503 10.9375 34.7503H29.0625C29.1454 34.7503 29.2249 34.7174 29.2835 34.6588C29.3421 34.6002 29.375 34.5207 29.375 34.4378V33.8128C29.375 33.5642 29.2762 33.3257 29.1004 33.1499C28.9246 32.9741 28.6861 32.8753 28.4375 32.8753Z",
    fill: "#668598"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 9,
    r: 8.25,
    fill: "#23BD86",
    stroke: "#F8FDFB",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7535 8.5H35.378V7.375C35.378 6.06562 34.3111 5 33 5C31.689 5 30.622 6.06562 30.622 7.375V8.5H30.2466C29.832 8.5 29.4956 8.83594 29.4956 9.25V12.25C29.4956 12.6641 29.832 13 30.2466 13H35.7535C36.1681 13 36.5045 12.6641 36.5045 12.25V9.25C36.5045 8.83594 36.1681 8.5 35.7535 8.5ZM34.1265 8.5H31.8736V7.375C31.8736 6.75469 32.3789 6.25 33 6.25C33.6211 6.25 34.1265 6.75469 34.1265 7.375V8.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankGreenLock);
export default __webpack_public_path__ + "static/media/bank-green-lock.8f17b526f35bc69e7eaa3008d5db71a4.svg";
export { ForwardRef as ReactComponent };